
/* =========================================================
   ÀMBA — HOMEPAGE HEADER COLOR CONTROL
   light = white logo and icons
   dark  = burgundy logo and icons
   Homepage only. Custom footer supported.
   ========================================================= */

(() => {
  if (!document.body.classList.contains('template-index')) return;

  const header = document.querySelector('theme-header.header');
  if (!header) return;

  const sectionTone = {
    'amba_hero_slideshow_8nDwV9': 'light',
    'slideshow_JbiwJD': 'light',
    'collection_tabs_MJPtRn': 'dark',
    'slideshow_RwzM88': 'light',
    'editorial_3_grid_slider_YadaN9': 'light',
    'slideshow_HFwxjh': 'light',
    'spacer_86yngW': 'dark',
    'slideshow_nRxR6V': 'light',
    'rich_text_9TtVjX': 'dark',
    'image_grid_boxes_Qtiief': 'light',
    'spacer_kLNCUe': 'dark',
    'rich_text_RVYKmm': 'dark',
    'slideshow_hEkG7H': 'light'
  };

  function getSections() {
    const sections = new Set(
      document.querySelectorAll(
        '#main-content .shopify-section, ' +
        '.shopify-section-group-footer-group'
      )
    );

    // Identify the actual custom-coded footer.
    const customFooter = document.querySelector('.ms-new-footer');

    if (customFooter) {
      sections.add(
        customFooter.closest('.shopify-section') || customFooter
      );
    }

    return Array.from(sections);
  }

  function getSectionTone(section) {
    if (
      section.matches('.ms-new-footer') ||
      section.querySelector('.ms-new-footer') ||
      section.classList.contains('shopify-section-group-footer-group')
    ) {
      return 'dark';
    }

    const key = Object.keys(sectionTone).find(
      id => section.id.includes(id)
    );

    return key ? sectionTone[key] : null;
  }

  function updateHeaderTone() {
    const sections = getSections();
    if (!sections.length) return;

    const headerRect = header.getBoundingClientRect();

    // Sample the area behind the logo, not the bottom of the header.
    const sampleY = Math.max(
      0,
      Math.min(
        window.innerHeight - 1,
        headerRect.top + headerRect.height / 2
      )
    );

    let activeSection = sections.find(section => {
      const rect = section.getBoundingClientRect();
      return rect.top <= sampleY && rect.bottom > sampleY;
    });

    // Fallback for the first frame or section-boundary transitions.
    if (!activeSection) {
      activeSection = sections
        .map(section => {
          const rect = section.getBoundingClientRect();

          const distance =
            sampleY < rect.top
              ? rect.top - sampleY
              : sampleY > rect.bottom
                ? sampleY - rect.bottom
                : 0;

          return { section, distance };
        })
        .filter(item => item.distance < window.innerHeight)
        .sort((a, b) => a.distance - b.distance)[0]?.section;
    }

    if (!activeSection) return;

    const tone = getSectionTone(activeSection);
    if (!tone) return;

    header.classList.toggle(
      'amba-home-header-light',
      tone === 'light'
    );

    header.classList.toggle(
      'amba-home-header-dark',
      tone === 'dark'
    );
  }

  let scheduled = false;

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      updateHeaderTone();
    });
  }

  window.addEventListener('scroll', scheduleUpdate, {
    passive: true
  });

  window.addEventListener('resize', scheduleUpdate, {
    passive: true
  });

  window.addEventListener('load', scheduleUpdate);

  // Initial state, including page refresh at a scrolled position.
  updateHeaderTone();
})();
